import { useCallback } from "react";

import {
  createTreeWalker,
  waitForNextFrame,
  canWalkOverNode,
  areContextsEqual,
  getMatchContext,
} from "../utils/parser";

export const useParser = ({
  preprocessedSections,
  canSearchInTables,
  isContentSplit,
}) => {
  const getAllMatches = useCallback(
    async (regExp) => {
      const newMatches = [];

      for (
        let sectionIdx = 0;
        sectionIdx < preprocessedSections.length;
        sectionIdx++
      ) {
        if (sectionIdx % 2) {
          await waitForNextFrame();
        }

        const wrapper = preprocessedSections[sectionIdx];
        const walker = createTreeWalker(wrapper, regExp, canSearchInTables);
        const matchesSectionIdx = isContentSplit ? sectionIdx : 0;

        let matchesCount = 0;
        let groupContext = null;

        newMatches[matchesSectionIdx] = newMatches[matchesSectionIdx] ?? [];

        const pushMatchesGroup = (groupContext) => {
          if (!groupContext || !matchesCount) {
            return;
          }
          newMatches[matchesSectionIdx].push({
            type: groupContext.type,
            meta: groupContext.meta,
            count: matchesCount,
          });
        };

        while (walker.nextNode()) {
          const node = walker.currentNode;
          if (!canWalkOverNode(node)) {
            continue;
          }
          const currContext = getMatchContext(node);
          const count = node.data.match(regExp)?.length || 0;

          if (areContextsEqual(groupContext, currContext)) {
            matchesCount += count;
            continue;
          }
          pushMatchesGroup(groupContext);
          matchesCount = count;
          groupContext = currContext;
        }

        pushMatchesGroup(groupContext);
      }

      return newMatches;
    },
    [preprocessedSections, canSearchInTables, isContentSplit]
  );

  return { getAllMatches };
};
